"use client";

import { ReactNode } from "react";

interface MainContentProps {
  children: ReactNode;
}

export default function MainContent({ children }: MainContentProps): React.ReactElement {
  return (
    <div data-main-content className="relative z-10 flex-1 min-w-0">
      {children}
    </div>
  );
}
